import { useEffect, useRef } from "react";
import { useRouter } from "next/router";

import { useUser } from "@/components/hooks/useUser";
import { analytics, clientSideIdentify } from "@/lib/segment/segment-client";

export default function Analytics() {
  const router = useRouter();
  const { user, isLoaded, isSuperUser, isAgencyUser, isDealManager } = useUser();
  const identifiedUserRef = useRef<string | null>(null);

  // Page tracking (production only)
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      analytics.page();

      const handleRouteChange = () => analytics.page();
      router.events.on("routeChangeComplete", handleRouteChange);

      return () => {
        router.events.off("routeChangeComplete", handleRouteChange);
      };
    }
  }, [router.events]);

  // User identification (production only)
  useEffect(() => {
    if (process.env.NODE_ENV === "production" && isLoaded && user && identifiedUserRef.current !== user.id) {
      clientSideIdentify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
        phoneNumber: user.primaryPhoneNumber?.phoneNumber,
        createdAt: user.createdAt,
        lastSignInAt: user.lastSignInAt,
        isSuperUser,
        isAgencyUser,
        isDealManager,
      });

      identifiedUserRef.current = user.id;
    }
  }, [isLoaded, user, isSuperUser, isAgencyUser, isDealManager]);

  return null;
}
